module.exports = __webpack_public_path__ + "static/media/img_2.aa8bd9cc.png";